module.exports = __webpack_public_path__ + "img/icon-supply3.64349a35.png";